import { Component } from '@theme/component'
import { requestIdleCallback as requestIdle } from '@theme/maths'

const MediaConfig = {
  markLoadedIdleTimeoutMs: 150,
  playerSelector: 'picture>img, video, svg, ui-video'
}

class UiLazyImage extends HTMLImageElement {
  constructor() {
    super()
    this.handleLazy = this.handleLazy.bind(this)
    this.onLoad = this.onLoad.bind(this)
    this.onError = this.onError.bind(this)
  }

  connectedCallback() {
    if (!this.media) {
      return
    }

    window.addEventListener('resize', this.handleLazy, { passive: true })

    this.mutationObserver = new MutationObserver(() => {
      this.classList.remove('loaded')
      this.handleLazy()
    })
    this.mutationObserver.observe(this, {
      attributeFilter: ['src', 'srcset'],
      attributes: true
    })

    this.handleLazy()
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleLazy)
    this.mutationObserver?.disconnect()
  }

   
  get media() {
    this._media = this._media || this.closest('.media')
    return this._media
  }

  handleLazy() {
    if (this.classList.contains('loaded')) {
      return
    }
    this.media?.classList.add('loading')

    if (this.complete) {
      this.onLoad()
      return
    }

    this.addEventListener('load', this.onLoad, { once: true })
    this.addEventListener('error', this.onError, { once: true })
  }

  onLoad() {
    requestIdle(() => this.#markLoaded(), {
      timeout: MediaConfig.markLoadedIdleTimeoutMs
    })
  }

  onError() {
    this.media?.classList.remove('loading')
  }

  #markLoaded() {
    this.classList.add('loaded')
    this.media?.classList.remove('loading')
  }
}

class UiMedia extends Component {
   
  get media() {
    return Array.from(this.querySelectorAll(MediaConfig.playerSelector))
  }
}

if (!customElements.get('ui-lazy-image')) {
  customElements.define('ui-lazy-image', UiLazyImage, { extends: 'img' })
}
if (!customElements.get('ui-media')) {
  customElements.define('ui-media', UiMedia)
}
